import { render, staticRenderFns } from "./ViewShipment.vue?vue&type=template&id=8a4c5bd8&scoped=true&"
import script from "./ViewShipment.vue?vue&type=script&lang=js&"
export * from "./ViewShipment.vue?vue&type=script&lang=js&"
import style0 from "./ViewShipment.vue?vue&type=style&index=0&id=8a4c5bd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4c5bd8",
  null
  
)

export default component.exports